import { IAlertProps } from './SnackbarProvider'

import { createContext, useContext } from 'react'

export interface SnackbarContextState {
  openSnackbar: ({ severity, title, text, action }: IAlertProps) => void
}

export const SnackbarContext = createContext<SnackbarContextState>({} as SnackbarContextState)

export function useSnackbar(): SnackbarContextState {
  return useContext(SnackbarContext)
}
